import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useHolyModeOptional } from "@/preferences/holy-mode";
import { SacredIcon, type SacredIconName } from "./sacred-icon";

export function PageHeader({
  title,
  description,
  actions,
  sacredIcon = "scroll",
  sacredCaption = "holy.pageCaption",
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  sacredIcon?: SacredIconName;
  sacredCaption?: string;
}) {
  const { enabled } = useHolyModeOptional();
  const { t } = useTranslation();
  return (
    <div className={`page-header mb-6 flex flex-wrap items-end justify-between gap-3${enabled ? " page-header--holy" : ""}`}>
      <div className="page-header__copy">
        {enabled ? <div className="page-header__caption"><span className="page-header__seal"><SacredIcon name={sacredIcon} size={30} /></span><span className="page-header__caption-text">{t(sacredCaption)}</span></div> : null}
        <h1 className="text-foreground text-2xl font-semibold">{title}</h1>
        {description ? <p className="text-muted mt-1 text-sm">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
